import styled from 'styled-components';
import Text from '@ids/components/Typography/Text';
import Heading from '@ids/components/Typography/Heading';

export const FAQSection = styled.section`
    padding: 10px min(5vw, 40px);
`;

export const Question = styled(Text)`
    margin: 1em 1em 1em 0;
`;

export const Answer = styled.div`
    margin-bottom: 1em;
    color: #323232;
    font-size: 14px;
    line-height: 1.4;
`;

export const SectionHeading = styled(Heading)`
    margin-bottom: 40px;
`;
